<template>
  <div class="faq">
    <div class="plan-condition py-4 border-b border-section_border">
      <h2 class="section-title text-lg text-center">
        よくあるご質問
      </h2>
    
      <div class="p-4 border-b border-section_border">
        <div class="p-4 bg-white rounded-lg">
          <dl>
            <dt class="text-lg font-semibold mb-1">
              旅行プランとはどんなサービスですか？
            </dt>
            <dd class="mb-4 pb-4 border-b border-section_border">
              おすすめの観光スポット等から簡単に旅行プランを立てられるサービスです。
            </dd>
            <dt class="text-lg font-semibold mb-1">
              旅行プランはどのように使えば良いですか？
            </dt>
            <dd class="mb-4 pb-4 border-b border-section_border">
              最初に行きたい観光スポットを選ぶだけで簡単にプランを立てられます。旅行前でも旅行中でも、柔軟に目的地を追加・削除したり、滞在時間を変更したりすることが可能です。
            </dd>
            <dt class="text-lg font-semibold mb-1">
              出発地や目的地は全国のすべての駅やバス停等に対応していますか？
            </dt>
            <dd class="mb-4 pb-4 border-b border-section_border">
              出発地や目的地は駅名等を入力した際に表示される駅名等のみに対応しています。表示されない出発地や目的地には対応していません。
            </dd>
            <dt class="text-lg font-semibold mb-1">
              リカバリーコードって何ですか？
            </dt>
            <dd class="mb-4 pb-4 border-b border-section_border">
              リカバリーコードとは旅行プランを保存した時に作成されるコードのことです。意図せずにプランが消えてしまった場合に、このリカバリーコードを入力することで作成したプランを再読み込みすることができます。（なお、ご自身でプランを削除した場合は、再読み込みすることはできません）
            </dd>
            <dt class="text-lg font-semibold mb-1">
              旅行プラン作成中に、お店の横に表示される距離って何ですか？
            </dt>
            <dd>
              <img  src="@/assets/images/faq-km.png" alt="" class="mr-2 mb-2 mt-2">
              上の画面はプラン作成中に、目的地を追加しようとすると出てきます。そこで出てくるお店の横の距離ですが、これは「直前のスポットとの距離」を表しています。この距離が大きければ遠い所にあるスポットとなるわけです。
            </dd>
          </dl>
        </div>
      </div>

      <div class="mt-4 px-4">
        <a class="button-secondary block button-icon icon-left" @click="back">
          <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
          <span>旅行プラントップに戻る</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "../constants";

export default {
  methods: {
    back: function () {
        this.$router.push({ path: '/plans' })
    },
    tohoku_maas_url: function () {
      var env_key = process.env.LINK_BASE_ENV || process.env.NODE_ENV
      return Constants.LINK_BASE_URL_LIST[env_key] + '/'
    }
  }
}
</script>